import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GetAssignmentQuery } from 'app/API.service';

export enum UserRemovalTypeEnum {
  UNASSIGN = 'UNASSIGN',
  PERMANENT_DELETE = 'PERMANENT_DELETE',
}

@Component({
  selector: 'cygov-collection-delete-user-modal',
  templateUrl: './collection-delete-user-modal.component.html',
  styleUrls: ['./collection-delete-user-modal.component.scss'],
  standalone: false,
})
export class CollectionDeleteUserModalComponent implements OnInit {
  @Input() userAssignment: GetAssignmentQuery;
  @Input() isCollaborative: boolean = true;
  @Input() showPermanentDelete: boolean = false;
  @Input() isDeletedUser: boolean = false;
  @Input() isSelfRemoval: boolean = false;

  @Output() modalResult = new EventEmitter<{ confirmed: boolean; removalType: UserRemovalTypeEnum }>();

  deleteModalMessage = '';
  permanentDeleteWarning = '';
  selectedRemovalType: UserRemovalTypeEnum = UserRemovalTypeEnum.UNASSIGN;
  UserRemovalTypeEnum = UserRemovalTypeEnum;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.isSelfRemoval) {
      this.deleteModalMessage =
        'You are about to remove yourself from this question. Your avatar will be removed, but all your answers, comments and artifacts ' +
        'will remain in the system.';
    } else if (this.isDeletedUser) {
      this.deleteModalMessage =
        'Please note, <span class="username">' +
        this.userAssignment.user.name +
        '</span> is a deleted user. Removing them will hide their avatar, but all answers, comments and artifacts ' +
        'will remain in the system.';
    } else if (this.isCollaborative) {
      this.deleteModalMessage =
        'Please note, you are about to remove the user <span class="username">' +
        this.userAssignment.user.name +
        '</span> from this question. Their previous data and artifacts will be retained.';
    } else {
      this.deleteModalMessage =
        'Please note, you are about to remove the user <span class="username">' +
        this.userAssignment.user.name +
        '</span> from this question. Since this is a Single/Average mode question, all answers and comments by this user will be removed.';
    }

    this.permanentDeleteWarning =
      '<strong>Warning:</strong> Permanently deleting will purge all data (answers, comments, artifacts) associated with ' +
      '<span class="username">' +
      this.userAssignment.user.name +
      '</span>. This action cannot be undone.';
  }

  confirm(): void {
    this.modalResult.emit({ confirmed: true, removalType: this.selectedRemovalType });
    this.activeModal.close();
  }

  closeUserDeleteModal(): void {
    this.modalResult.emit({ confirmed: true, removalType: this.selectedRemovalType });
  }
}
